import { V2 } from 'shared';
import axios from 'shared/lib/axios';

export const getUserV2 = ({ userId }: { userId: number }) => {
  return axios.get<V2.User>(`/v2/users/${userId}`);
};
